import React from "react";

import Heading from "../../shared/components/UIElements/Heading";
import {
	ArrowPathIcon,
	ArrowUturnRightIcon,
	ChatBubbleOvalLeftIcon,
} from "@heroicons/react/16/solid";
import Button from "../../shared/components/FormElements/Button";
import { useClerk } from "@clerk/clerk-react";

import AuthFooter from "../../users/components/AuthFooter";
import MainLogo from "../../shared/components/Branding/MainLogo";

const NoActiveSubscription = () => {
	const { signOut } = useClerk();

	return (
		<div className="bg-white h-screen grid lg:grid-cols-2">
			<div className="grid content-between px-12 sm:px-24">
				<MainLogo className="mt-12" />

				<div>
					<ArrowPathIcon className="size-10 text-brand-intense mb-4" />
					<Heading size="2">
						Je hebt geen actief abonnement
					</Heading>
					<div className="text-lg text-slate-500 ">
						<p className="mt-6">
							Het lijkt erop dat je geen actief abonnement hebt op
							DentHR.
						</p>
						<p className="mt-6">
							Klopt dit niet? Neem contact met ons op via de chat
							rechtsonder, dan lossen we het voor je op.
						</p>
					</div>

					<div className="flex gap-3 mt-5">
						<Button
							type="button"
							ghost
							onClick={() => {
								window.Intercom("show");
							}}
							iconPrefix={ChatBubbleOvalLeftIcon}
						>
							Open de chat
						</Button>
						<Button
							type="button"
							onClick={() => {
								signOut();
							}}
							ghost
							iconPrefix={ArrowUturnRightIcon}
						>
							Uitloggen
						</Button>
					</div>
				</div>
				<div className="mb-12 sm:flex justify-between">
					<AuthFooter />
				</div>
			</div>
		</div>
	);
};

export default NoActiveSubscription;
